/* eslint-disable @typescript-eslint/no-unsafe-argument */
import cx from 'classnames';
import Cookies from 'js-cookie';
import React, { useEffect, useState } from 'react';
import { FEATURE_BRANCH_COOKIE, MFE_DEV_OVERRIDE_COOKIE } from '|/hooks/use-global-mfe-config';
import styles from './control-panel.module.css';

type MfeSource = 'testazure' | 'localhost' | 'feature-branch';

const getInitialSource = (): MfeSource => {
  if (Cookies.get(MFE_DEV_OVERRIDE_COOKIE) === 'true') return 'localhost';
  if (Cookies.get(FEATURE_BRANCH_COOKIE)) return 'feature-branch';
  return 'testazure';
};

const MfeDevOverride = () => {
  const [showInterface, setShowInterface] = useState(false);
  const [mfeSource, setMfeSource] = useState<MfeSource>('testazure');
  const [featureBranchName, setFeatureBranchName] = useState('');
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    setMfeSource(getInitialSource());
    setFeatureBranchName(String(Cookies.get(FEATURE_BRANCH_COOKIE) ?? ''));
    setIsLoading(false);
  }, []);

  const isProduction = process.env.NODE_ENV === 'production';

  if (isProduction || isLoading) {
    return null;
  }

  const isOverrideActive = mfeSource !== 'testazure';

  const handleSourceChange = (source: MfeSource) => {
    setMfeSource(source);

    Cookies.remove(MFE_DEV_OVERRIDE_COOKIE);
    Cookies.remove(FEATURE_BRANCH_COOKIE);
    setFeatureBranchName('');

    if (source === 'localhost') {
      Cookies.set(MFE_DEV_OVERRIDE_COOKIE, 'true');
      window.location.reload();
    } else if (source === 'testazure') {
      window.location.reload();
    }
  };

  return (
    <div className={styles.wrapper}>
      <button
        className={cx(styles.tab, showInterface && styles.expanded)}
        onClick={() => {
          setShowInterface(!showInterface);
        }}
        data-analytics-id="pp_devpanel_mfe_override"
      >
        {isOverrideActive && (
          <span
            style={{
              width: 8,
              height: 8,
              borderRadius: '50%',
              backgroundColor: '#ff4444',
              display: 'inline-block',
              marginRight: 6
            }}
          />
        )}
        Verifx MFE
      </button>

      {showInterface && (
        <div className={styles.content}>
          <div className={styles.experimentGroup}>Load MFE from:</div>
          <label className={styles.radio}>
            <input
              type="radio"
              name="mfe-source"
              checked={mfeSource === 'testazure'}
              onChange={() => {
                handleSourceChange('testazure');
              }}
              data-analytics-id="pp_devpanel_mfe_testazure"
            />
            testazure
          </label>
          <label className={styles.radio}>
            <input
              type="radio"
              name="mfe-source"
              checked={mfeSource === 'localhost'}
              onChange={() => {
                handleSourceChange('localhost');
              }}
              data-analytics-id="pp_devpanel_mfe_localhost"
            />
            localhost
          </label>
          <label className={styles.radio}>
            <input
              type="radio"
              name="mfe-source"
              checked={mfeSource === 'feature-branch'}
              onChange={() => {
                setMfeSource('feature-branch');
              }}
              data-analytics-id="pp_devpanel_mfe_feature_branch"
            />
            feature branch
          </label>
          {mfeSource === 'feature-branch' && (
            <div className={styles.input}>
              <label htmlFor="ppcp-feature-branch">Branch name:</label>
              <input
                id="ppcp-feature-branch"
                type="text"
                value={featureBranchName}
                autoComplete="none"
                spellCheck="false"
                autoCapitalize="none"
                className={styles.input}
                data-analytics-id="pp_devpanel_feature_branch_input"
                onChange={e => {
                  setFeatureBranchName(e.target.value);
                }}
              />
              <button
                data-analytics-id="pp_devpanel_feature_branch_reload"
                className={styles.refreshBtn}
                disabled={!featureBranchName}
                onClick={() => {
                  Cookies.remove(MFE_DEV_OVERRIDE_COOKIE);
                  Cookies.set(FEATURE_BRANCH_COOKIE, featureBranchName);
                  window.location.reload();
                }}
              >
                Reload Page
              </button>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default MfeDevOverride;
